var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitterBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.983398 16.4347C3.19673 16.5903 5.12562 16.0525 6.90229 14.6892C5.99562 14.5803 5.20562 14.3436 4.53895 13.8159C3.89007 13.2981 3.39229 12.6525 3.12562 11.7703H4.77007C4.77895 11.7336 4.78784 11.697 4.79673 11.6514C3.89007 11.3881 3.11673 10.9147 2.53895 10.1603C1.96118 9.41585 1.67784 8.55141 1.65007 7.60474C2.22784 7.76919 2.77895 7.93252 3.33895 8.08697C3.35673 8.0503 3.3834 8.01474 3.40118 7.97808C2.60118 7.30474 2.0234 6.49585 1.81118 5.4503C1.59211 4.43054 1.74627 3.36602 2.24562 2.4503C4.46784 5.10474 7.25784 6.57808 10.6878 6.82363C10.5812 5.95919 10.5723 5.15919 10.8656 4.37697C11.879 1.6403 15.2912 0.766966 17.4145 2.73141C17.6545 2.94919 17.859 2.98585 18.1167 2.89474C18.819 2.6403 19.5112 2.36808 20.2312 2.09474C19.9556 2.99474 19.3601 3.65919 18.659 4.30474C19.3423 4.12252 20.0267 3.93141 20.7023 3.74919C20.729 3.77697 20.7556 3.79474 20.7823 3.82252C20.2667 4.36808 19.769 4.94141 19.2101 5.43252C18.9078 5.69585 18.8101 5.94141 18.7923 6.34141C18.6323 10.797 16.8456 14.397 13.0423 16.6625C9.16784 18.9625 5.17895 18.8259 1.25118 16.6347C1.18007 16.5903 1.11784 16.5347 0.98451 16.4347H0.983398Z",
    fill: "#04111D"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitterBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter_black.8b4162d87448a4d235b6b0b455201681.svg";